import { Formik } from "formik";
import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { useLocation } from "react-router-dom";

import axios from "axios";
import { Link } from "react-router-dom";
import "../../Components/Login/Login";
import Myaccount from "../../Components/MyAccount/Myaccount";
import CartBannerComponent from "../../Components/ProdectBanner/CartBannerComponent";
import "./Register.css";

const Register = ({ setlogin }) => {
  const phoneRegExp = /^(?:\+?88)?01[1-9]\d{8}$/; //bd phone regex
  const [isVendor, setIsVendor] = useState(false);
  const location = useLocation();

  // Check for vendor parameter in URL
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get('vendor') === 'true' || searchParams.get('registervendor') === 'true') {
      setIsVendor(true);
    } else {
      setIsVendor(false);
    }
  }, [location.search]);

  const customerRegistrationSchema = Yup.object().shape({
    firstName: Yup.string().required("Required"),
    lastName: Yup.string().required("Required"),
    email: Yup.string().email("Invalid email").required("Required"),
    phoneNumber: Yup.string().matches(phoneRegExp, "Phone number is not valid").required("Required"),
    address: Yup.string().required("Required"),
    country: Yup.string().required("Required"),
    city: Yup.string().required("Required"),
    zip: Yup.string().required("Required"),
    password: Yup.string()
      .min(6, "Too Short!")
      .max(50, "Too Long!")
      .required("Required"),

    agreeToTerms: Yup.boolean()
      .oneOf([true], "You must accept the Privacy Policy")
      .required("Required"),

    password_confirmation: Yup.string().oneOf(
      [Yup.ref("password"), null],
      "Passwords must match"
    ),
  });

  const vendorRegistrationSchema = Yup.object().shape({
    shopName: Yup.string().required("Required"),
    name: Yup.string().required("Required"),
    email: Yup.string().email("Invalid email").required("Required"),
    phoneNumber: Yup.string().matches(phoneRegExp, "Phone number is not valid").required("Required"),
    password: Yup.string().min(6, "Too Short!").max(50, "Too Long!").required("Required"),
    password_confirmation: Yup.string().oneOf([Yup.ref("password"), null], "Passwords must match"),
    photo: Yup.mixed().required("Required").test(
      "fileType", "Only JPEG, JPG, PNG, SVG files are allowed",
      value => {
        if (!value) return false;
        const type = (value.type || "").split(';')[0].toLowerCase();
        // Fallback: check by file extension if type is empty
        if (!type) {
          const ext = value.name.split('.').pop().toLowerCase();
          return ["jpeg", "jpg", "png", "svg"].includes(ext);
        }
        return ["image/jpeg", "image/jpg", "image/png", "image/svg+xml"].includes(type);
      }
    ),
    // --- NEW ---
    taxId: Yup.string().required("Tax ID is required"),
    businessLicense: Yup.mixed().required("Business license is required").test(
      "fileType", "Only PDF, JPEG, JPG, PNG files are allowed",
      value => {
        if (!value) return false;
        const type = value.type.split(';')[0];
        return ["application/pdf", "image/jpeg", "image/jpg", "image/png"].includes(type);
      }
    ),
    bankName: Yup.string().required("Bank name is required"),
    bankAccountNumber: Yup.string().required("Bank account number is required"),
    accountHolderName: Yup.string().required("Account holder name is required"),
    agreeToTerms: Yup.boolean()
      .oneOf([true], "You must accept the Vendor Terms & Conditions")
      .required("Required"),
  });

  const handleRegistrationSubmit = (values, actions) => {
    console.log("regformvalues", values);
    //network request here

    let regPostObj = {};
    let regUrl = "";

    if (isVendor) {
      const formData = new FormData();
      formData.append('name', values.name);
      formData.append('email', values.email);
      formData.append('phone', values.phoneNumber);
      formData.append('password', values.password);
      if (values.shopName) formData.append('shop_name', values.shopName);
      if (values.photo) formData.append('photo', values.photo);
      // --- NEW ---
      if (values.taxId) formData.append('tax_id', values.taxId);
      if (values.businessLicense) formData.append('business_license', values.businessLicense);
      if (values.bankName) formData.append('bank_name', values.bankName);
      if (values.bankAccountNumber) formData.append('bank_account_number', values.bankAccountNumber);
      if (values.accountHolderName) formData.append('account_holder_name', values.accountHolderName);

      regPostObj = formData;
      regUrl = `${process.env.REACT_APP_API_URL}/vendor-register`;
    } else {
      // Customer registration
      regPostObj = {
        name: values.firstName + " " + values.lastName,
        email: values.email,
        address: values.address,
        country: values.country,
        city: values.city,
        zip: values.zip,
        phone: values.phoneNumber,
        password: values.password,
        password_confirmation: values.password_confirmation
      };
      regUrl = `${process.env.REACT_APP_API_URL}/user-registration`;
    }

    axios.post(regUrl, regPostObj)
      .then((response) => {
        if (response.status === 200) {
          console.log(response);
          actions.resetForm();
          alert("Registration successful");
        }
      })
      .catch((error) => {
        console.log(error);
        alert("Registration failure");
      });
  };

  return (
    <div>
      <CartBannerComponent title="Register" />
      <div className="container">
        <div className="row content">
          <div className="col-md-9 decration">
            <h1>Register Account</h1>
            <p>
              If you already have an account with us, please login at the
              <Link to="/login"> login page.</Link>
            </p>

            <Formik
              enableReinitialize={true}
              initialValues={isVendor ? {
                shopName: "",
                name: "",
                email: "",
                phoneNumber: "",
                password: "",
                password_confirmation: "",
                photo: null,
                // --- NEW ---
                taxId: "",
                businessLicense: null,
                bankName: "",
                bankAccountNumber: "",
                accountHolderName: "",
                agreeToTerms: false,
              } : {
                firstName: "",
                lastName: "",
                email: "",
                phoneNumber: "",
                address: "",
                country: "",
                city: "",
                zip: "",
                password: "",
                password_confirmation: "",
                agreeToTerms: false,
              }}
              validationSchema={isVendor ? vendorRegistrationSchema : customerRegistrationSchema}
              onSubmit={handleRegistrationSubmit}
            >
              {({
                errors,
                touched,
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                setFieldValue,
                setFieldTouched
              }) => (
                <form onSubmit={handleSubmit}>
                  <div className="vendor-toggle">
                    <label className="toggle-label">
                      <input
                        type="radio"
                        value="customer"
                        checked={!isVendor}
                        onChange={(e) => setIsVendor(e.target.value === "vendor")}
                      />
                      Customer Registration
                    </label>
                    <label className="toggle-label">
                      <input
                        type="radio"
                        value="vendor"
                        checked={isVendor}
                        onChange={(e) => setIsVendor(e.target.value === "vendor")}
                      />
                      Vendor Registration
                    </label>
                  </div>

                  {isVendor ? (
                    <>
                      <fieldset id="vendor-account">
                        <legend className="legender">Vendor Information</legend>
                        <div className="form-group required">
                          <label
                            htmlFor="input-shopname"
                            className="col-sm-2 control-label"
                          >
                            Shop Name
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="shopName"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.shopName}
                              placeholder="Shop Name"
                              id="input-shopname"
                              className="from-control"
                            />
                            {touched.shopName && errors.shopName && (
                              <div style={{ color: "red" }}>{errors.shopName}</div>
                            )}
                          </div>
                        </div>
                        <div className="form-group required">
                          <label
                            htmlFor="input-name"
                            className="col-sm-2 control-label"
                          >
                            Full Name
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="name"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.name}
                              placeholder="Full Name"
                              id="input-name"
                              className="from-control"
                            />
                            {touched.name && errors.name && (
                              <div style={{ color: "red" }}>{errors.name}</div>
                            )}
                          </div>
                        </div>
                        <div className="form-group required">
                          <label
                            htmlFor="input-email"
                            className="col-sm-2 control-label"
                          >
                            E-Mail
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="email"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.email}
                              placeholder="E-Mail"
                              id="input-email"
                              className="from-control"
                            />
                            {touched.email && errors.email && (
                              <div style={{ color: "red" }}>{errors.email}</div>
                            )}
                          </div>
                        </div>
                        <div className="form-group required">
                          <label
                            htmlFor="input-telephone"
                            className="col-sm-2 control-label"
                          >
                            Phone Number
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="phoneNumber"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.phoneNumber}
                              placeholder="Telephone"
                              id="input-telephone"
                              className="from-control"
                            />
                            {touched.phoneNumber && errors.phoneNumber && (
                              <div style={{ color: "red" }}>
                                {errors.phoneNumber}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="form-group required">
                          <label
                            htmlFor="input-password"
                            className="col-sm-2 control-label"
                          >
                            Password
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="password"
                              name="password"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.password}
                              placeholder="Password"
                              id="input-password"
                              className="from-control"
                            />
                            {touched.password && errors.password && (
                              <div style={{ color: "red" }}>{errors.password}</div>
                            )}
                          </div>
                        </div>
                        <div className="form-group required">
                          <label
                            htmlFor="input-password_confirmation"
                            className="col-sm-2 control-label"
                          >
                            Password Confirm
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="password"
                              name="password_confirmation"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.password_confirmation}
                              placeholder="Password Confirm"
                              id="input-password_confirmation"
                              className="from-control"
                            />
                            {touched.password_confirmation &&
                              errors.password_confirmation && (
                                <div style={{ color: "red" }}>
                                  {errors.password_confirmation}
                                </div>
                              )}
                          </div>
                        </div>
                        <div className="form-group required">
                          <label
                            htmlFor="input-photo"
                            className="col-sm-2 control-label"
                          >
                            Photo
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="file"
                              name="photo"
                              onChange={(e) => {
                                // For file inputs, we bypass handleChange and directly set the field value
                                if (e.target.files && e.target.files[0]) {
                                  setFieldValue('photo', e.target.files[0]);
                                } else {
                                  // If no file selected, set to null
                                  setFieldValue('photo', null);
                                }

                                // Manually mark as touched
                                setFieldTouched('photo', true, false);
                              }}
                              onBlur={handleBlur}
                              id="input-photo"
                              className="from-control"
                            />
                            {touched.photo && errors.photo && (
                              <div style={{ color: "red" }}>{errors.photo}</div>
                            )}
                          </div>
                        </div>
                      </fieldset>

                      <fieldset id="vendor-business-docs">
                        <legend className="legender">Business Documents</legend>

                        {/* Tax ID */}
                        <div className="form-group required">
                          <label htmlFor="input-taxId" className="col-sm-2 control-label">Tax ID</label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="taxId"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.taxId}
                              placeholder="Tax Identification Number"
                              id="input-taxId"
                              className="from-control"
                            />
                            {touched.taxId && errors.taxId && (
                              <div style={{ color: "red" }}>{errors.taxId}</div>
                            )}
                          </div>
                        </div>

                        {/* Business License */}
                        <div className="form-group required">
                          <label htmlFor="input-businessLicense" className="col-sm-2 control-label">Business License</label>
                          <div className="col-sm-10">
                            <input
                              type="file"
                              name="businessLicense"
                              onChange={(e) => {
                                if (e.target.files && e.target.files[0]) {
                                  setFieldValue('businessLicense', e.target.files[0]);
                                } else {
                                  setFieldValue('businessLicense', null);
                                }
                              }}
                              onBlur={handleBlur}
                              id="input-businessLicense"
                              className="from-control"
                            />
                            {touched.businessLicense && errors.businessLicense && (
                              <div style={{ color: "red" }}>{errors.businessLicense}</div>
                            )}
                          </div>
                        </div>

                        {/* Bank Name */}
                        <div className="form-group required">
                          <label htmlFor="input-bankName" className="col-sm-2 control-label">Bank Name</label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="bankName"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.bankName}
                              placeholder="Bank Name"
                              id="input-bankName"
                              className="from-control"
                            />
                            {touched.bankName && errors.bankName && (
                              <div style={{ color: "red" }}>{errors.bankName}</div>
                            )}
                          </div>
                        </div>

                        {/* Bank Account Number */}
                        <div className="form-group required">
                          <label htmlFor="input-bankAccountNumber" className="col-sm-2 control-label">Account Number</label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="bankAccountNumber"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.bankAccountNumber}
                              placeholder="Bank Account Number"
                              id="input-bankAccountNumber"
                              className="from-control"
                            />
                            {touched.bankAccountNumber && errors.bankAccountNumber && (
                              <div style={{ color: "red" }}>{errors.bankAccountNumber}</div>
                            )}
                          </div>
                        </div>

                        {/* Account Holder Name */}
                        <div className="form-group required">
                          <label htmlFor="input-accountHolderName" className="col-sm-2 control-label">Account Holder</label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="accountHolderName"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.accountHolderName}
                              placeholder="Account Holder Name"
                              id="input-accountHolderName"
                              className="from-control"
                            />
                            {touched.accountHolderName && errors.accountHolderName && (
                              <div style={{ color: "red" }}>{errors.accountHolderName}</div>
                            )}
                          </div>
                        </div>
                      </fieldset>
                    </>
                  ) : (
                    <>
                      <fieldset id="accounts">
                        <legend className="legender">Your Personal Details</legend>
                        <div className="form-group required">
                          <label
                            htmlFor="input-firstname"
                            className="col-sm-2 control-label"
                          >
                            First Name
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="firstName"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.firstName}
                              placeholder="First Name"
                              id="input-firstname"
                              className="from-control"
                            />
                            {touched.firstName && errors.firstName && (
                              <div style={{ color: "red" }}>{errors.firstName}</div>
                            )}
                          </div>
                        </div>
                        <div className="form-group required">
                          <label
                            htmlFor="input-lastname"
                            className="col-sm-2 control-label"
                          >
                            Last Name
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="lastName"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.lastName}
                              placeholder="Last Name"
                              id="input-lastname"
                              className="from-control"
                            />
                            {touched.lastName && errors.lastName && (
                              <div style={{ color: "red" }}>{errors.lastName}</div>
                            )}
                          </div>
                        </div>
                        <div className="form-group required">
                          <label
                            htmlFor="input-email"
                            className="col-sm-2 control-label"
                          >
                            E-Mail
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="email"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.email}
                              placeholder="E-Mail"
                              id="input-email"
                              className="from-control"
                            />
                            {touched.email && errors.email && (
                              <div style={{ color: "red" }}>{errors.email}</div>
                            )}
                          </div>
                        </div>
                        <div className="form-group required">
                          <label
                            htmlFor="input-telephone"
                            className="col-sm-2 control-label"
                          >
                            Phone Number
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="phoneNumber"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.phoneNumber}
                              placeholder="Telephone"
                              id="input-telephone"
                              className="from-control"
                            />
                            {touched.phoneNumber && errors.phoneNumber && (
                              <div style={{ color: "red" }}>
                                {errors.phoneNumber}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="form-group required">
                          <label
                            htmlFor="input-address"
                            className="col-sm-2 control-label"
                          >
                            Address
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="address"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.address}
                              placeholder="Address"
                              id="input-address"
                              className="from-control"
                            />
                            {touched.address && errors.address && (
                              <div style={{ color: "red" }}>{errors.address}</div>
                            )}
                          </div>
                        </div>
                        <div className="form-group required">
                          <label
                            htmlFor="input-country"
                            className="col-sm-2 control-label"
                          >
                            Country
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="country"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.country}
                              placeholder="Country"
                              id="input-country"
                              className="from-control"
                            />
                            {touched.country && errors.country && (
                              <div style={{ color: "red" }}>{errors.country}</div>
                            )}
                          </div>
                        </div>
                        <div className="form-group required">
                          <label
                            htmlFor="input-city"
                            className="col-sm-2 control-label"
                          >
                            City
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="city"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.city}
                              placeholder="City"
                              id="input-city"
                              className="from-control"
                            />
                            {touched.city && errors.city && (
                              <div style={{ color: "red" }}>{errors.city}</div>
                            )}
                          </div>
                        </div>
                        <div className="form-group required">
                          <label
                            htmlFor="input-zip"
                            className="col-sm-2 control-label"
                          >
                            Zip
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              name="zip"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.zip}
                              placeholder="Zip"
                              id="input-zip"
                              className="from-control"
                            />
                            {touched.zip && errors.zip && (
                              <div style={{ color: "red" }}>{errors.zip}</div>
                            )}
                          </div>
                        </div>
                      </fieldset>
                      <fieldset>
                        <legend className="legender">Your Password</legend>
                        <div className="form-group required">
                          <label
                            htmlFor="input-password"
                            className="col-sm-2 control-label"
                          >
                            Password
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="password"
                              name="password"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.password}
                              placeholder="Password"
                              id="input-password"
                              className="from-control"
                            />
                            {touched.password && errors.password && (
                              <div style={{ color: "red" }}>{errors.password}</div>
                            )}
                          </div>
                        </div>
                        <div className="form-group required">
                          <label
                            htmlFor="input-password_confirmation"
                            className="col-sm-2 control-label"
                          >
                            Password Confirm
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="password"
                              name="password_confirmation"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.password_confirmation}
                              placeholder="Password Confirm"
                              id="input-password_confirmation"
                              className="from-control"
                            />
                            {touched.password_confirmation &&
                              errors.password_confirmation && (
                                <div style={{ color: "red" }}>
                                  {errors.password_confirmation}
                                </div>
                              )}
                          </div>
                        </div>
                      </fieldset>
                      <fieldset>
                        <legend className="legender">Newsletter</legend>
                        <div className="form-group required">
                          <label
                            htmlFor="input-first Name"
                            className="col-sm-2 control-label"
                          >
                            Subscribe
                          </label>
                          <div className="col-sm-10">
                            <label htmlFor="" className="radio-inline">
                              {" "}
                              <input type="radio" name="newslatter" value={1} /> Yes
                            </label>
                            <label htmlFor="" className="radio-inline">
                              {" "}
                              <input
                                type="radio"
                                name="newslatter"
                                value={0}
                                checked="checked"
                              />{" "}
                              No{" "}
                            </label>
                          </div>
                        </div>
                      </fieldset>
                    </>
                  )}

                  <div className="buttons">
                    <div className="pull-right">
                      {isVendor ? (
                        <>
                          <div style={{ marginBottom: "10px" }}>
                            <label style={{ cursor: "pointer" }}>
                              <input
                                type="checkbox"
                                name="agreeToTerms"
                                checked={values.agreeToTerms}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                style={{ marginRight: "6px" }}
                              />
                              I have read and agree to the{" "}
                              <a href="/vendor-terms" target="_blank" rel="noopener noreferrer" className="agree">
                                <b>Vendor Terms & Conditions</b>
                              </a>
                            </label>
                            {touched.agreeToTerms && errors.agreeToTerms && (
                              <div style={{ color: "red", fontSize: "13px" }}>
                                {errors.agreeToTerms}
                              </div>
                            )}
                          </div>
                          <input
                            type="submit"
                            value="Register as Vendor"
                            className="btn btn-primary"
                            disabled={!values.agreeToTerms}
                          />
                        </>
                      ) : (
                        <>
                          <div style={{ marginBottom: "10px" }}>
                            <label style={{ cursor: "pointer" }}>
                              <input
                                type="checkbox"
                                name="agreeToTerms"
                                checked={values.agreeToTerms}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                style={{ marginRight: "6px" }}
                              />
                              I have read and agree to the{" "}
                              <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" className="agree">
                                <b>Privacy Policy</b>
                              </a>
                            </label>
                            {touched.agreeToTerms && errors.agreeToTerms && (
                              <div style={{ color: "red", fontSize: "13px" }}>
                                {errors.agreeToTerms}
                              </div>
                            )}
                          </div>
                          <input
                            type="submit"
                            value="Continue"
                            className="btn btn-primary"
                            disabled={!values.agreeToTerms}
                          />
                        </>
                      )}
                    </div>
                  </div>
                </form>
              )}
            </Formik>
          </div>
          <Myaccount setlogin={setlogin} />
        </div>
      </div>
    </div>
  );
};

export default Register;
